import React from "react";
import "./Sustainability.css";
import substainblityImage from "../images/sustainblity.jpeg"; // Replace with your actual image path]

const Sustainability = () => {
  return (
    <section className="sustainability-section">
      <div className="sustainability-container">

        <div className="sustainability-image">
          <img
            src={substainblityImage}
            alt="Wood Worker"
          />
        </div>

        <div className="sustainability-content">
          <h2>SUSTAINABILITY</h2>

          <div className="point">
            <span className="circle"></span>
            <p>
              All the timber used in making our furniture is harvested
              ethically, from legal and environment friendly sources
            </p>
          </div>

          <div className="point">
            <span className="circle"></span>
            <p>
              Our care for the environment ensures that all the wood that
              goes into creating every piece of furniture is cultivated
              through sustainable forestry practices
            </p>
          </div>

          <div className="point">
            <span className="circle"></span>
            <p>
              We realize the importance of maintaining harmony in the
              ecosystem and this is deeply ingrained in the fabric of our
              work culture and practices
            </p>
          </div>

          <div className="point">
            <span className="circle"></span>
            <p>
              We work diligently towards reduction of waste and
              recyclability of products with our advanced machinery
            </p>
          </div>
        </div>

      </div>
    </section>
  );
};

export default Sustainability;